import React, { useState } from 'react'
import FormattedMessage from '../../../../helpers/FormattedMessage'

import styles from './LocalCard.module.scss'
import { Select } from '../../../../components/Select'
import { CustomInput } from '../../../../components/CustomInput'
import editIcon from '../../../../assets/icons/icn_edit-b.svg'
import closeIcon from '../../../../assets/icons/icn-close.svg'

interface IProps {
  children?: React.ReactNode
  description?: string
  value?: { size: string, amount: number }
  errorMessage?: string
  hideContent?: boolean
  onClose?: () => void
  onEdit?: (value: { size: string, amount: number }) => void
  onContentOpen?: () => void
  allSizes: string[]
  sizesString: string
}

export const LocalCard = ({
  value,
  hideContent,
  onEdit,
  onClose,
  allSizes,
  sizesString
}: IProps) => {
  const [size, setSize] = useState(value?.size)
  const [amount, setAmount] = useState(value?.amount)
  const [isOpen, setIsOpen] = useState(false)


  const setSizeValue = (size: string | number) => {
    setSize(`${size}`)
  }

  const setAmountValue = (amount: string) => {
    setAmount(Number(amount))
  }

  const editItems = () => {
    if (size !== '' || amount !== 0) {
      setIsOpen(false)
      size && amount && onEdit && onEdit({ size, amount })
    }
  }

  return (
    <div className={`${styles.Wrapper} ${(hideContent || onClose) && styles.Flex}`}>
      <div>
        {!isOpen && value &&
        <div className={styles.Description}>
            <div><FormattedMessage id="EventCloth.stage4.size"/>: {value.size}</div>
            <div><FormattedMessage id="EventCloth.stage4.quantity"/>: {value.amount}</div>
        </div>
        }
        {isOpen && (
            <div className={styles.SizesInputs}>
              <Select
                values={allSizes}
                onChange={setSizeValue}
                title="EventCloth.stage4.selectSize"
                rotate
              >
                {size ?
                  size
                  : sizesString}
              </Select>
              <CustomInput
                title="EventCloth.stage4.quantity"
                placeholder="Skriv antal här"
                onChange={setAmountValue}
                value={`${amount}`}
              />
              <button
                className={styles.AddSizesButton}
                onClick={editItems}
              >
                <FormattedMessage id={'saveChanges'}/>
              </button>
            </div>
        )}
      </div>
      {!isOpen && (
      <div className={styles.BtnWrapper}>
        <button className={styles.OpenBtn} onClick={() => { setIsOpen(true) }}>
            <img src={editIcon} alt={'edit'}/>
        </button>
        {onClose &&
        <button className={styles.CloseBtn} onClick={onClose}>
            <img src={closeIcon} alt={'close'}/>
        </button>
        }
      </div>
      )}
    </div>
  )
}
